import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'intervalHour'
})
export class IntervalHourPipe implements PipeTransform {
    transform(value: number): string {
        if(value >= 0){
            const min = value % 60;
            const hour = (value - min) / 60;
            return this.double(Math.floor(hour)) ;
        } else {
            return '- -';
        }
    }

    private double(val: number): string {
        return val / 10 >= 1 ? val.toString() : '0' + val;
    }
}
